const TYPE_COLOR = {
  int: '#79c0ff',
  float: '#79c0ff',
  str: '#a5d6ff',
  bool: '#ff7b72',
  list: '#7ee787',
  dict: '#7ee787',
  tuple: '#7ee787',
  set: '#7ee787',
  NoneType: '#8b949e',
};

export default function VariableInspector({ namespace }) {
  const entries = Object.entries(namespace || {});

  if (entries.length === 0) {
    return (
      <div className="pylab-var-empty">
        <p>Run a cell to see variables here.</p>
      </div>
    );
  }

  return (
    <div className="pylab-var-list">
      {entries.map(([name, { value, type }]) => (
        <div key={name} className="pylab-var-row">
          <span className="pylab-var-name">{name}</span>
          <span
            className="pylab-var-type"
            style={{ color: TYPE_COLOR[type] || '#8b949e' }}
          >
            {type}
          </span>
          <span className="pylab-var-value" title={value}>{value}</span>
        </div>
      ))}
    </div>
  );
}
